import { render, staticRenderFns } from "./OrderSend.vue?vue&type=template&id=4d8165a4&scoped=true&"
import script from "./OrderSend.vue?vue&type=script&lang=js&"
export * from "./OrderSend.vue?vue&type=script&lang=js&"
import style0 from "./OrderSend.vue?vue&type=style&index=0&id=4d8165a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8165a4",
  null
  
)

export default component.exports